<template lang="pug">
    div
        v-layout(row justify-left)
            v-flex(text-xs-left)
                v-btn(v-if="!startPage" depressed class="white--text Slides-prevslide" @click.prevent="prevSlide")
                  font-awesome-icon(icon="arrow-left")                                          
        v-layout(row justify-right)
            v-flex(text-xs-right)
                v-btn(v-if="!endPage" depressed class="white--text Slides-nextslide" @click.prevent="nextSlide")
                    font-awesome-icon(icon="arrow-right")            
        carousel(:perPage="1" @pageChange="pageChange" :mouseDrag="false" paginationColor='#1464A5' paginationActiveColor='#072146' ref="carousel")
            slide(v-for="slide in currentStep.slides")
                v-layout.Slides-layout(row)
                    v-flex.Slides-left(xl6 lg6 md6 sm6)
                        imageLoader(:imagesrc="slide.image")                    
                    v-flex.Slides-right(xl6 lg6 md6 sm6 v-html="slide.text")
        v-spacer.py-2        
        el-button.ButtonNext(v-if="endPage" @click="nextStep" type="primary") Ok, ¡Entendido!
        el-button.ButtonNext(type="info" :disabled="true" v-else) Ok, ¡Entendido!        
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import { Carousel, Slide } from 'vue-carousel';
import imageLoader from "@/components/image-loader/image-loader";
import buttonNext2 from '@/components/button-next/button-next2';

export default {
  name: 'Slides',
  components:{
	Carousel,
    Slide,
    imageLoader,
    buttonNext2
  },
  computed: {
    ...mapGetters(['currentStep']),     
  },
  methods: {
    ...mapActions(['nextStepSCORM']),
    nextSlide() {      
      this.$refs.carousel.advancePage();
      this.startPage = !this.$refs.carousel.canAdvanceBackward;
      this.endPage = !this.$refs.carousel.canAdvanceForward;
    },
    prevSlide() {      
      this.$refs.carousel.advancePage("backward");
      this.startPage = !this.$refs.carousel.canAdvanceBackward;
      this.endPage = !this.$refs.carousel.canAdvanceForward;
    },
    nextStep() {        
        this.$refs.carousel.advancePage("backward");
        this.startPage = true;
        this.endPage = false;        
        this.nextStepSCORM();
    },
    pageChange(page) {
        if(page === 0) {
            this.startPage = true;
            this.endPage = false;
        } else if (this.$refs.carousel.canAdvanceForward === false) {
            this.startPage = false;
            this.endPage = true;
        }
    }
  },
  data() {
        return {
            startPage: true,
            endPage: false
        }
    }
}
</script>

<style scoped>
    @import 'slides.scss';
</style>

